<template>
  <div class="home-wrapper">
    <home-slider />
    <booking-vehicle :is-home="true" />
    <home-offers />
  </div>
</template>
<script>

export default {
  name: 'HomeLayout',
  components: {
    HomeSlider: () => import(/* webpackChunkName: "home"  */ `./HomeSlider`),
    BookingVehicle: () => import(/* webpackChunkName: "home"  */ `../Booking/BookingVehicle`),
    HomeOffers: () => import(/* webpackChunkName: "home"  */ `./HomeOffers/HomeOffers`),
  },
}
</script>
<style lang="scss" scoped>

.home-wrapper {
  display: flex;
  flex-direction: column-reverse;
  width: 100%;

  @include if-min(350px) {
    flex-direction: column;
  }
}
</style>
